import type { Signal } from "@suse-o11y/signal";
import React from "react";

import type { TimeRange } from "../../../../../../app/state/view/timeline/TimeRange";
import type { MonitorCheckStatus } from "../../../../../../common/openapi";
import { ComponentBoundary } from "../../../../../../components/_component-boundary";

import { MonitorStatusProvider } from "./_monitor-status-provider";
import { MonitorStatusDetails } from "./MonitorStatusDetails";
import { MonitorStatusInfo } from "./MonitorStatusInfo";

interface MonitorStatusProps {
	timeRange: Signal<TimeRange>;
	monitorStatus: MonitorCheckStatus;
}

export const MonitorStatus: React.FC<MonitorStatusProps> = ({ timeRange, monitorStatus }) => (
	<ComponentBoundary component={monitorStatus.component}>
		<MonitorStatusProvider timeRange={timeRange}>
			<div className="space-y-4">
				<MonitorStatusInfo monitorStatus={monitorStatus} />
				<MonitorStatusDetails monitorStatus={monitorStatus} />
			</div>
		</MonitorStatusProvider>
	</ComponentBoundary>
);
